<template>
	<div class="flex flex-wrap gap-3 justify-center items-center">
		<div v-if="showLabel" class="mr-2 text-sm font-medium opacity-80">
			{{ label }}
		</div>

		<div
			v-for="badge in paymentBadges"
			:key="badge.key"
			class="flex items-center px-3 py-1.5 bg-white rounded shadow-sm"
			:aria-label="badge.label"
			:title="badge.label"
		>
			<AppIcon :name="badge.icon" class="w-10 h-6" :aria-label="badge.label" />
		</div>

		<div
			v-if="showSecure"
			class="flex items-center px-2 py-1 text-xs text-gray-600 bg-gray-100 rounded"
		>
			<AppIcon
				name="heroicons-outline:lock-closed"
				class="mr-1 w-4 h-4 text-gray-600"
				aria-label="Sichere Zahlung"
			/>
			<span>Sichere Zahlung</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AppIcon from '@/components/icons/AppIcon.vue';

interface Props {
	methods?: ('visa' | 'mastercard' | 'paypal' | 'card')[];
	showLabel?: boolean;
	label?: string;
	showSecure?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	methods: () => ['visa', 'mastercard', 'paypal'],
	showLabel: false,
	label: 'Wir akzeptieren:',
	showSecure: true,
});

const methodIconMap: Record<string, { icon: string; label: string }> = {
	visa: { icon: 'logos:visa', label: 'Visa' },
	mastercard: { icon: 'logos:mastercard', label: 'Mastercard' },
	paypal: { icon: 'logos:paypal', label: 'PayPal' },
	card: { icon: 'heroicons-outline:credit-card', label: 'Kreditkarte' },
};

const paymentBadges = computed(() => {
	const methods = props.methods || [];
	const hasSpecificCards = methods.includes('visa') || methods.includes('mastercard');

	return methods
		.map((method) => {
			if (method === 'card' && hasSpecificCards) {
				return null;
			}
			const config = methodIconMap[method] || methodIconMap.card;
			return {
				key: method,
				...config,
			};
		})
		.filter(Boolean) as { key: string; icon: string; label: string }[];
});
</script>
